/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'cardFilter' })

export class CardFilterPipe implements PipeTransform { /* Using this filter for Notes card as well */
    transform(cards: any, args: any) {
        if (cards && args) {
            return cards.filter((item: any) => (item.name && item.name.toLowerCase().match(args.toLowerCase())));
        }else{
            return cards;
        }
    }
}

@Pipe({ name: 'cardTabFilter' })

export class CardTabFilterPipe implements PipeTransform {
    transform(cards: any, args:any) {
        if (cards) {
            return cards.filter((item: any) => ((item.group == args)||(args == 'All')));
        }
    }
}